import * as Action from "./action";

const defineInitialState = () => ({
  data: null,
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$save.ACTION:
      return {
        ...state,
        data: action?.payload,
      };
    default:
      return state;
  }
}

export function persister({ data }) {
  return {
    data,
  };
}
